import Vue from 'vue'
import utils from '@/assets/js/utils'

/**
 * 过滤性别
 */
Vue.filter('filterGender', (status) => {
    let item = Vue.prototype.$const.GENDER.find(value => value.value === Number(status))
    if (item) {
        return item.label
    } else {
        return status
    }
});
Vue.filter('filterBillStatus', (status) => {
    let item = Vue.prototype.$const.BILLSTATUS.find(value => value.value === Number(status))
    if (item) {
        return item.label
    } else {
        return status
    }
});
Vue.filter('fliterCardType', (cardType, content) => {
    let item = Vue.prototype.$const.CARDTYPELIST.find(value => value.value === Number(cardType))
    if (item) {
        return item.label
    } else {
        return content || '中国居民身份证'
    }
});
Vue.filter('fliterCancelChannel', (cancelChannel) => {
    let item = Vue.prototype.$const.CANCELCHANNEL.find(value => value.value == cancelChannel)
    if (item) {
        return item.label
    } else {
        return cancelChannel ? '美团取消' : '-'
    }
});

/**
 * 时间戳过滤为指定格式，默认格式为
 */
Vue.filter('filterTime', (timestamp, format = 'YYYY/MM/DD HH:mm:SS') => {
    return Vue.prototype.$utils.timeFn(timestamp, format)
});

Vue.filter('filterTime2', (timestamp, format = 'YYYY/MM/DD HH:mm:SS') => {
    if(timestamp == 4102329600) {
        return '长期有效'
    } else {
        return Vue.prototype.$utils.timeFn(timestamp, format)
    }
});

Vue.filter('filterStatus', (status) => {
    let item = Vue.prototype.$const.PLACEMENTSTATUS.find(value => value.value == status)
    if (item) {
        return item.label
    } else {
        return status
    }
});

/**
 * 过滤站点类型
 */
Vue.filter('filterLineType', (type) => {
    let item = Vue.prototype.$const.LINETYPE.find(value => value.value === Number(type))
    if (item) {
        return item.label
    } else {
        return type
    }
});

/**
 * 过滤订单状态
 */
function findOrderCharteredStatusItem(status) {
    return Vue.prototype.$const.ORDERCHARTEREDSTATUS.find(value => {
        if (value.value === Number(status)) {
            return value
        } else if (typeof value.value === 'string' && value.value.indexOf(',') !== -1) {
            let arr = value.value.split(',').map(val => Number(val));
            if (arr.includes(status)) {
                return value
            }
        }
    });
}
Vue.filter('filterOrderCharteredStatus', (status) => {
    let item = findOrderCharteredStatusItem(status);
    return item ? item.label : status
});
Vue.filter('filterOrderCharteredStatusType', (status) => {
    let item = findOrderCharteredStatusItem(status);
    return item ? (item.type || 'info') : 'info'
});
Vue.filter('filterCzAccountType', (status) => {
    let findItem = Vue.prototype.$const.CZACCOUNTTYPE.find(item => {
        if (+item.value === Number(status)) {
            return item
        } else if (typeof item.value === 'string' && item.value.indexOf(',') !== -1) {
            let arr = item.value.split(',').map(val => Number(val));
            if (arr.includes(status)) {
                return item
            }
        }
    });
    if (findItem) {
        return findItem.label
    } else {
        return status
    }
});
/**
 * 过滤订单状态
 */
function findOrderStatusItem(status) {
    return Vue.prototype.$const.ORDERSTATUS.find(value => {
        if (value.value === Number(status)) {
            return value
        } else if (typeof value.value === 'string' && value.value.indexOf(',') !== -1) {
            let arr = value.value.split(',').map(val => Number(val));
            if (arr.includes(status)) {
                return value
            }
        }
    });
}
Vue.filter('filterOrderStatus', (status) => {
    let item = findOrderStatusItem(status);
    return item ? item.label : status
});
Vue.filter('filterOrderStatusType', (status) => {
    let item = findOrderStatusItem(status);
    return item ? (item.type || 'info') : 'info'
});
/**
 * 过滤订单子状态
 */
Vue.filter('filterOrderSubStatus', (status) => {
    let item = Vue.prototype.$const.ORDERSUBSTATUS.find(value => {
        if (value.value === Number(status)) {
            return value
        } else if (typeof value.value === 'string' && value.value.indexOf(',') !== -1) {
            let arr = value.value.split(',').map(val => Number(val));
            if (arr.includes(status)) {
                return value
            }
        }
    });
    if (item) {
        return item.label
    } else {
        return status
    }
});

/**
 * 过滤状态
 */
Vue.filter('filterConst', (status, type, label = 'label') => {
    let item = Vue.prototype.$const[type].find(value => value.value == status);

    if (item) {
        return item[label]
    } else {
        return status || '-'
    }
});

// 周末
Vue.filter('week', utils.getWeek)


Vue.filter('filterMoney', (money,symbol = '',decimals = 2, ) => {
    return new Intl.NumberFormat("zh-CN", {
        // style: "currency", // 货币形式
        // currency: "CNY", // "CNY"是人民币
        // currencyDisplay: "symbol", // 默认"symbol"，中文中代表"¥"符号
        // useGrouping: true, // 是否使用分组分隔符，如千位分隔符或千/万/亿分隔符，默认为true
        // minimumIntegerDigits: 1, // 使用的整数数字的最小数目.可能的值是从1到21,默认值是1
        // minimumFractionDigits: 2, // 使用的小数位数的最小数目.可能的值是从 0 到 20
        maximumFractionDigits: decimals, // 使用的小数位数的最大数目。可能的值是从 0 到 20
    }).format(money);
});

Vue.filter('filterMaskIdCard', (id) => {
    return Vue.prototype.$utils.maskIdCard(id)
})

Vue.filter('filterMaskPhone', (name) => {
    return Vue.prototype.$utils.maskPhone(name)
})

/**
 * 出发时间格式化
 * 与earliestDepartureTime同日仅显示时分，同年仅显示日月时分，跨年显示年月日时分
 * @param {number} timestamp - 时间戳
 * @param {number} earliestTime - 最早出发时间戳
 * @returns {string} 格式化后的时间字符串
 */
Vue.filter('filterDepartureTime', (timestamp, earliestTime) => {
    if (!timestamp || !earliestTime) {
        return '-';
    }

    // 转换为毫秒时间戳
    const time = timestamp * 1000;
    const earliest = earliestTime * 1000;

    const date = new Date(time);
    const earliestDate = new Date(earliest);

    // 获取年月日时分
    const year = date.getFullYear();
    const month = Vue.prototype.$utils.zfill(date.getMonth() + 1);
    const day = Vue.prototype.$utils.zfill(date.getDate());
    const hour = Vue.prototype.$utils.zfill(date.getHours());
    const minute = Vue.prototype.$utils.zfill(date.getMinutes());

    // 判断是否同年
    const isSameYear = year === earliestDate.getFullYear();
    // 判断是否同日
    const isSameDay = isSameYear &&
                     date.getMonth() === earliestDate.getMonth() &&
                     date.getDate() === earliestDate.getDate();

    if (isSameDay) {
        // 同日只显示时分
        return `${hour}:${minute}`;
    } else if (isSameYear) {
        // 同年显示月日时分
        return `${month}/${day} ${hour}:${minute}`;
    } else {
        // 跨年显示年月日时分
        return `${year}/${month}/${day} ${hour}:${minute}`;
    }
});

// 注意：filterConst 过滤器已在第158行定义，支持3个参数 (status, type, label)
// 此处不再重复定义，避免覆盖

// /**
//  * 订单状态过滤器
//  */
// Vue.filter('filterOrderStatus', (status) => {
//     const statusMap = {
//         10: '待支付',
//         20: '待开始',
//         30: '行程中',
//         45: '已完成',
//         50: '待退款',
//         60: '已退票',
//         70: '已取消'
//     }
//     return statusMap[status] || status
// });
